import React, { Component } from "react";
import commonUtil from "../../../utils/commonUtil";
import RadioButton from "../../../components/ZUILib/RadioButton";
import _ from "lodash";
import { browserHistory } from "react-router";
import { UIBrands2 } from "../../../utils/clientConstant";

const applicationRoutes = commonUtil.getApplicationRoutes();

class GiftListTableFiltersModalWap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onMesdecompraDropDown: false,
      onTiendasDropDown: false,
      onBonificacionDropDown: false,
      title: "",
      disableButton: false,
    };

    this.eventId = this.props.eventId;
    this.eventInfo = this.props.eventInfo;
    this.isViewAll = false;
    this.currentPage = 1;
  }

  componentDidMount() {
    this.setState({ title: this.props.title || "" });
    const scrollY = window.scrollY;

    document.body.classList.add('body-no-scroll-fixed');
    document.body.style.top = `-${scrollY}px`;

    const {
      selectedOption,
      selectedStore,
      selectedBonus,
      handleOptionChange,
      handleStoreChange,
      handleBonusChange,
      filteringParameters,
    } = this.props;

    if (filteringParameters.length > 0) {
      filteringParameters.forEach((filterParam) => {
        let selectedObj = {};
        if (filterParam.type == 'date' && (!selectedOption?.value || (filterParam.value != selectedOption?.value))) {
          selectedObj.value = filterParam.value;
          let label;

          if (filterParam.value == '1') {
            label = 'Ultimo mes';
          } else if (filterParam.value == '3') {
            label = 'Ultimos 3 meses';
          }
          if (filterParam.value == '6') {
            label = 'Ultimos 6 meses';
          }

          selectedObj.displayName = label;
          handleOptionChange(selectedObj);
        } else if (filterParam.type == 'store' && (!selectedStore?.value || (filterParam.value != selectedStore?.value))) {
          selectedObj.value = filterParam.value;
          const selectedStore = UIBrands2.find(
            (brand) => brand.id == filterParam.value,
          );
          selectedObj.displayName = selectedStore.label;
          handleStoreChange(selectedObj);
        } else if (
          filterParam.type == 'bonusApplicable' &&
          (!selectedBonus?.value || (filterParam.value != selectedBonus?.value))
        ) {
          selectedObj.value = filterParam.value;
          selectedObj.displayName =
            filterParam.value == 'true'
              ? 'Aplica para bono'
              : 'No aplica para bono';
          handleBonusChange(selectedObj);
        }
      });
    }

    const count = this.props.filterProductsCount(this.props?.initialPurchasedItemsDetailsData?.itemsInfo || [], this.props.filteringParameters);
    this.props.setFilteredProductsCount(count);
  }
  

  onDropDownClick = (label) => {
    this.setState((prevState) => {
      switch (label) {
        case "compra":
          return {
            onMesdecompraDropDown: !prevState.onMesdecompraDropDown,
            onTiendasDropDown: false,
            onBonificacionDropDown: false,
          };
        case "tiendas":
          return {
            onTiendasDropDown: !prevState.onTiendasDropDown,
            onMesdecompraDropDown: false,
            onBonificacionDropDown: false,
          };
        case "bonificacion":
          return {
            onBonificacionDropDown: !prevState.onBonificacionDropDown,
            onTiendasDropDown: false,
            onMesdecompraDropDown: false,
          };
        default:
          return {};
      }
    });
  };

  onViewAllClick = () => {
    this.isViewAll = true;
    this.props.getFilterSorted(
      this.props.filteringParameters,
      this.props.sortingParameters,
      this.currentPage,
      true
    );
  };

  rediectToPage = () => {
    browserHistory.push(
      commonUtil.routeTo(applicationRoutes.giftList, {
        eventID: this.props.eventId,
      })
    );
  };

  render() {
    const {
      onMesdecompraDropDown,
      onTiendasDropDown,
      onBonificacionDropDown,
      title,
    } = this.state;

    const {
      isPhysical,
      isElectronic,
      isPersonal,
      selectedOption,
      selectedStore,
      selectedBonus,
      handleOptionChange,
      handleStoreChange,
      handleBonusChange,
      selectedTheme,
      isBonusContainerVisible,
    } = this.props;

    const themeColor500 = selectedTheme?.color_500;
    const themeColor50 = selectedTheme?.color_50;
    const themeColor700 = selectedTheme?.color_700;
    const themeColor100 = selectedTheme?.color_100;

    const RegresarLink = {
      text: "Regresar",
      children: "Regresar",
      cssClass: "lightLink size-Medium",
      onClickHandler: this.rediectToPage,
    };
    const viewAll = {
      text: "Ver todo",
      href: "javascript:void(0);",
      onClickHandler: this.onViewAllClick,
    };

    const showEverything = {
      id: "showEveryThingRadioBox",
      disable: false,
      defaultValue: "",
      options: [
        {
          value: "1",
          labelResourceId: "Ultimo mes",
          disabled: false,
        },
        {
          value: "3",
          labelResourceId: "Ultimos 3 meses",
          disabled: false,
        },
        {
          value: "6",
          labelResourceId: "Ultimos 6 meses",
          disabled: false,
        },
      ],
    };

    const allStores = {
      id: "allStoresRadiobox",
      disable: false,
      title: commonUtil.getLabel(
        this.props.lables["Physical Gifts Details Page"],
        "accountStatement.physical.dropdownLabel2"
      ),
      options: [],
    };
    UIBrands2.forEach((val, index) => {
      allStores.options.push({
        id: allStores.id + "_rbbox_" + index,
        value: val.id,
        label: val.label,
        disabled: false,
        isChecked: false,
      });
    });

    const applyForBonus = {
      id: "applyForBonusRadioBox",
      disable: false,
      defaultValue: "",
      options: [
        {
          value: "true",
          labelResourceId: "Aplica para bono",
          disabled: false,
        },
        {
          value: "false",
          labelResourceId: "No aplica para bono",
          disabled: false,
        },
      ],
    };

    const downArrowIconPath =
      "M16.59 8.29492L12 12.8749L7.41 8.29492L6 9.70492L12 15.7049L18 9.70492L16.59 8.29492Z";
    const upArrowIconPath =
      "M12 8.29492L6 14.2949L7.41 15.7049L12 11.1249L16.59 15.7049L18 14.2949L12 8.29492Z";

    const closeIconGrey = (selectedValue, fpType) => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="cursor-pointer"
          onClick={() =>
            this.props.onClearFilters(false, selectedValue, fpType)
          }
        >
          <path
            d="M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z"
            fill="#333333"
          />
        </svg>
      );
    };

    const isFiltersSelected =
      Object.keys(this.props.selectedOption).length > 0 ||
      Object.keys(this.props.selectedStore).length > 0 ||
      Object.keys(this.props.selectedBonus).length > 0;


    return (
      <div id="event-gift-modal-overlay" className="evnt_modal_overlay">
        <div className="modal-content-event">
          <div className="evnt-modal-header">
            <h4 className="modal-title">{title}</h4>
            <button
              className="close-button"
              onClick={this.props.onCloseModal}
              aria-label="Cerrar modal"
            >
              <img
                src={commonUtil.getAssetURL() + "/images/close.svg"}
                alt=""
                className="icon_vozcliente"
              />
            </button>
          </div>
          <div className="evnt_modal_body" onClick={(e) => e.stopPropagation()}>
            <div>
              <>
                {(this.props.filteringParameters &&
                    this.props.filteringParameters.length > 0 && isFiltersSelected) && (
                  <div
                    className="giftlist-filter-selected-chip-container-wap"
                    data-layout="Vertical"
                  >
                    <div className="giftlist-filter-selected-chip-wrapper-wap">
                      {selectedOption?.displayName && this.props.filteringParameters.some(item => item.type === 'date') && (
                        <div className="giftlist-filter-selected-chip-wap">
                          <div className="giftlist-filter-selected-chip-text-wap">
                            {selectedOption.displayName}
                          </div>
                          {closeIconGrey(selectedOption.value, "date")}
                        </div>
                      )}

                      {selectedStore?.displayName && this.props.filteringParameters.some(item => item.type === 'store') && (
                        <div className="giftlist-filter-selected-chip-wap">
                          <div className="giftlist-filter-selected-chip-text-wap">
                            {selectedStore.displayName}
                          </div>
                          {closeIconGrey(selectedStore.value, "store")}
                        </div>
                      )}

                      {selectedBonus?.displayName && this.props.filteringParameters.some(item => item.type === 'bonusApplicable') && (
                        <div className="giftlist-filter-selected-chip-wap">
                          <div className="giftlist-filter-selected-chip-text-wap">
                            {selectedBonus.displayName}
                          </div>
                          {closeIconGrey(
                            selectedBonus.value,
                            "bonusApplicable"
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Mes de compra */}
                <div
                  className={`giftlist-filter-mesdecompra-container-wap ${
                    onMesdecompraDropDown
                      ? "giftlist-filter-mesdecompra-container-open-wap"
                      : ""
                  }`}
                >
                  <div className="giftlist-filter-mesdecompra-box-wap">
                    <div className="giftlist-filter-mesdecompra-heading-wap">
                      <span className="giftlist-filter-mesdecompra-text-wap">
                        {commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.gift.table.purchase.month.text',
                        )}{selectedOption?.displayName ? ':' : ''}
                      </span>
                      {selectedOption?.displayName && (
                        <span className="giftlist-filter-text-selected-wap">
                          {selectedOption.displayName}
                        </span>
                      )}
                    </div>
                    <svg
                      onClick={() => this.onDropDownClick("compra")}
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      className="cursor-pointer"
                    >
                      <path
                        d={`${
                          onMesdecompraDropDown
                            ? upArrowIconPath
                            : downArrowIconPath
                        }`}
                        fill="#333333"
                      />
                    </svg>
                  </div>

                  {onMesdecompraDropDown && (
                    <div className="giftlist-filter-mesdecompra-items-box-wap">
                      {showEverything.options.map((option, index) => (
                        <div
                          key={index}
                          className="giftlist-filter-mesdecompra-item-box-wap radioGL"
                        >
                          <RadioButton
                            key={index}
                            displayName={option.labelResourceId}
                            id={`option${index}`}
                            value={option.value}
                            title={option.labelResourceId}
                            checked={option.value == selectedOption?.value}
                            radioCssClass={"radio"}
                            name={showEverything.id}
                            onChangeFunction={handleOptionChange}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Tiendas */}
                <div
                  className={`giftlist-filter-mesdecompra-container-wap ${
                    onTiendasDropDown
                      ? "giftlist-filter-mesdecompra-container-open-wap"
                      : ""
                  }`}
                >
                  <div className="giftlist-filter-mesdecompra-box-wap">
                    <div className="giftlist-filter-mesdecompra-heading-wap">
                      <span className="giftlist-filter-mesdecompra-text-wap">
                        {commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.gift.table.store.text',
                        )}{selectedStore?.displayName ? ':' : ''}
                      </span>
                      {selectedStore?.displayName && (
                        <span className="giftlist-filter-text-selected-wap">
                          {selectedStore.displayName}
                        </span>
                      )}
                    </div>
                    <svg
                      onClick={() => this.onDropDownClick("tiendas")}
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      className="cursor-pointer"
                    >
                      <path
                        d={`${
                          onTiendasDropDown
                            ? upArrowIconPath
                            : downArrowIconPath
                        }`}
                        fill="#333333"
                      />
                    </svg>
                  </div>

                  {onTiendasDropDown && (
                    <div className="giftlist-filter-mesdecompra-items-box-wap">
                      {allStores.options.map((store, index) => (
                        <div
                          key={index}
                          className="giftlist-filter-mesdecompra-item-box-wap radioGL"
                        >
                          <RadioButton
                            key={index}
                            displayName={store.label}
                            id={store.id}
                            value={store.value}
                            title={store.label}
                            checked={store.value == selectedStore?.value}
                            radioCssClass={"radio"}
                            name={"Tiendas"}
                            onChangeFunction={handleStoreChange}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Bonificación */}
                {(isBonusContainerVisible && !isElectronic) && (
                  <div
                    className={`giftlist-filter-mesdecompra-container-wap ${
                      onBonificacionDropDown
                        ? "giftlist-filter-mesdecompra-container-open-wap"
                        : ""
                    }`}
                  >
                    <div className="giftlist-filter-mesdecompra-box-wap">
                      <div className="giftlist-filter-mesdecompra-heading-wap">
                        <span className="giftlist-filter-mesdecompra-text-wap">
                          {commonUtil.getLabel(
                            this.props.lables.eventAccountStatement,
                            'accountStatement.summary.bonus.heading',
                          )}{selectedBonus?.displayName ? ':' : ''}
                        </span>
                        {selectedBonus?.displayName && (
                          <span className="giftlist-filter-text-selected-wap">
                            {selectedBonus.displayName}
                          </span>
                        )}
                      </div>
                      <svg
                        onClick={() => this.onDropDownClick("bonificacion")}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        className="cursor-pointer"
                      >
                        <path
                          d={`${
                            onBonificacionDropDown
                              ? upArrowIconPath
                              : downArrowIconPath
                          }`}
                          fill="#333333"
                        />
                      </svg>
                    </div>

                    {onBonificacionDropDown && (
                      <div className="giftlist-filter-mesdecompra-items-box-wap">
                        {applyForBonus.options.map((bonus, index) => (
                          <div
                            key={index}
                            className="giftlist-filter-mesdecompra-item-box-wap radioGL"
                          >
                            <RadioButton
                              key={index}
                              displayName={bonus.labelResourceId}
                              id={`bonus${index}`}
                              value={bonus.value}
                              title={bonus.labelResourceId}
                              checked={bonus.value == selectedBonus?.value}
                              radioCssClass={"radio"}
                              name={applyForBonus.id}
                              onChangeFunction={handleBonusChange}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </>

              <div
                className="giftlist-filter-button-div-wap"
                data-active-filters="True"
              >
                <div className="giftlist-filter-button-inner-wap">
                  {this.props.filteringParameters &&
                    this.props.filteringParameters.length > 0 && (
                      <button
                        style={{ '--color-500': themeColor500 }}
                        className='giftlist-filter-button-clear-wap'
                        data-left-icon='false'
                        data-right-icon='false'
                        data-size='Medium'
                        data-state='Normal'
                        data-type='Secondary'
                        onClick={() => this.props.onClearFilters(true)}
                      >
                        <div
                          style={{ '--color-500': themeColor500 }}
                          className='giftlist-filter-button-clear-text-wap'
                        >
                          {commonUtil.getLabel(
                            this.props.lables.eventAccountStatement,
                            'accountStatement.gift.table.clean.filters.text',
                          )}
                        </div>
                      </button>
                    )}

                  <button
                    style={{'--color-500': themeColor500}}
                    className="giftlist-filter-button-apply-wap"
                    data-left-icon="false"
                    data-right-icon="false"
                    data-size="Medium"
                    data-state="Normal"
                    data-type="Primary"
                    onClick={this.props.onViewItemsClick}
                  >
                    <div className="giftlist-filter-button-apply-text-wap">
                      {commonUtil.getLabel(
                        this.props.lables.eventAccountStatement,
                        'accountStatement.gift.table.view.articles.text',
                        [this.props.filteredProductsCount || '0']
                      )}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GiftListTableFiltersModalWap;
